import React, { Component } from 'react';

import language from '../../../assets/languages/language';
import Chapter from '../Chapter';
import Header from '../Header';
export class ESGNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  fetchNotesPDFById = async item => {
    const myWindow = window.open(item.pdf_file);
    myWindow.focus();
  };
  render() {
    return (
      <div className='animated fadeIn'>
        <Header title={language.LC().NOTES} />

        <Chapter
          headerImage={'/img/notes/notes_icon1.svg'}
          apiEndpoint={'/esg/notes/allPdf'}
          imageWidth={40}
          callingComponent={'notes'}
          fetchNotesPDFById={this.fetchNotesPDFById}
          replacementFields={{ name: 'essay_ques_name' }}
          {...this.props}
        />
      </div>
    );
  }
}

export default ESGNotes;



// WEBPACK FOOTER //
// ./src/views/ESG/Notes/index.jsx